
import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import "flag-icon-css/css/flag-icon.min.css";

@Component
export default class UCountryFlag extends Vue {
  // Props

  @Prop({ default: "" })
  public countryCode!: string;

  @Prop({ default: 24 })
  public size!: number;

  // Render

  public render(h: CreateElement) {
    const code = (this.countryCode || "").toLowerCase();
    if (!code) return;
    return h("span", {
      style: {
        ["font-size"]: `${this.size}px`
      },
      class: [`flag-icon`, `flag-icon-squared`, `flag-icon-${code}`].join(" ")
    });
  }
}
